import React from 'react';
import { Route } from 'react-router-dom';
import DarAnalysis from '../../Daranalysis/Darfiles/QuestionUplode.js';
import DarAnswer from '../../Daranalysis/Darfiles/EnterDarAnswer.js';
import DarQuestions from '../../Daranalysis/Darfiles/ViewQuestions.js';
import Distributor from '../../Daranalysis/Darfiles/Distributorpage.js';
import DarAnswerData from '../../Daranalysis/Darfiles/Potentialdata.js';
import DarAnswerDristributor from '../../Daranalysis/Darfiles/DarAnswerWeightage.js';
import DarFullAnswer from '../../Daranalysis/Darfiles/DarFullAnswer.js';
import Carddar from '../../Daranalysis/CardsGrid.js';
import { guardRoute } from '../ProtectedRoute';

export const darRoutes = [
  <Route key="dar-list" path="/dar-List" element={guardRoute(<Carddar />, '/dar-List')} />,
  <Route
    key="dar-distributor"
    path="/DarDistributor"
    element={guardRoute(<Distributor />, '/DarDistributor')}
  />,
  <Route
    key="dar-question-upload"
    path="/DarQuestion-uplode"
    element={guardRoute(<DarAnalysis />, '/DarQuestion-uplode')}
  />,
  <Route
    key="dar-questions"
    path="/Update-DarQuestions"
    element={guardRoute(<DarQuestions />, '/Update-DarQuestions')}
  />,
  <Route
    key="dar-answer"
    path="/Take-DarAnalysis"
    element={guardRoute(<DarAnswer />, '/Take-DarAnalysis')}
  />,
  <Route
    key="dar-potential"
    path="/Dar-Potentiallevel"
    element={guardRoute(<DarAnswerData />, '/Dar-Potentiallevel')}
  />,
  <Route
    key="dar-answer-value"
    path="/DarAnswer-value"
    element={guardRoute(<DarAnswerDristributor />, '/DarAnswer-value')}
  />,
  <Route
    key="dar-full-answer"
    path="/DarFullAnswer"
    element={guardRoute(<DarFullAnswer />, '/DarFullAnswer')}
  />,
];
